import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types'


const ConsentSuccess = (props) => (
  <Row>
    <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
      <h1>
        Bedankt!
      </h1>
      <p>
        De aanmelding is in behandeling bij {props.clubName}.
      </p>
    </Col>
  </Row>
);

ConsentSuccess.propTypes = {
  clubName: PropTypes.string,
}

export default ConsentSuccess



// WEBPACK FOOTER //
// ./src/personconsent/ConsentSuccess.jsx